import { Component } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { Router } from "@angular/router";
import { Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  appPages: { title: string; url: string; icon: string }[];
  role: string = "";

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private menuCtrl: MenuController,
    private router: Router
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is("cordova")) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      }

      this.role = sessionStorage.getItem("role");
      if (this.role == "HO SALES USER") {
        this.appPages = [
          {
            title: "UPDATE BANNERS",
            url: "/home",
            icon: "home",
          },
          {
            title: "REPORTS",
            url: "/list",
            icon: "document",
          },
          {
            title: "ONBOARDING REQUESTS",
            url: "/requests",
            icon: "git-pull-request",
          },
          {
            title: "TRANSACTIONS",
            url: "/transaction",
            icon: "card",
          },
           {
            title: "CAMPAIGNS",
            url: "/campaign",
            icon: "calendar",
          },                 
          // {
          //   title: "COUPON ADMIN",
          //   url: "/coupon-admin",
          //   icon: "trophy",
          // },  
          {
            title: "SECONDARY PAGE",
            url: "/secondary-page",
            icon: "document",
          },     
          {
            title: "SCHEME TRACKER",
            url: "/scheme-tracker",
            icon: "calendar",
          },
           {
            title: "SOLAR USERS",
            url: "/solar",
            icon: "person",
          },
          {
            title: "DB-TRANSACTIONS",
            url: "/db-transaction",
            icon: "card",
          },
          {
            title: "CUSTOMER LOYALTY",
            url: "/cust-transaction",
            icon: "timer",
          },
          {
            title: "SEARCH INDPOWER SERIAL NO",
            url: "/search-indpower",
            icon: "search",
          },
          {
            title: "LTD LEADS",
            url: "/lead-ltd",
            icon: "lock",
          },
          {
            title: "PDF MANAGER",
            url: "/upload",
            icon: "document",
          },
          {
            title: "DMS PRIMARY ORDERS",
            url: "/primary-admin",
            icon: "cart",
          },
          
        ];
      } else if (this.role == "CHANNEL HEAD") {
        this.appPages = [
         {
            title: "COUPON ADMIN",
            url: "/coupon-admin",
            icon: "trophy",
          },  
        ];
      } else if (this.role == "MIS") {
        this.appPages = [
          {
            title: "UPDATE BANNERS",
            url: "/home",
            icon: "home",
          },
          {
            title: "REPORTS",
            url: "/list",
            icon: "document",
          },
          {
            title: "SOLAR USERS",
            url: "/solar",
            icon: "person",
          },
          {
            title: "CAMPAIGNS",
            url: "/campaign",
            icon: "calendar",
          },
        ];
      } else {
        this.appPages = [
          {
            title: "UPDATE BANNERS",
            url: "/home",
            icon: "home",
          },
          {
            title: "REPORTS",
            url: "/list",
            icon: "document",
          },
          {
            title: "SOLAR USERS",
            url: "/solar",
            icon: "person",
          },
          {
            title: "TRANSACTIONS",
            url: "/transaction",
            icon: "card",
          },
        ];
      }
    });
  }
  // logout() {
  //   localStorage.removeItem("username");
  //   // console.log("LogOut!!");
  //   this.menuCtrl.enable(false, "right-menu");
  //   this.router.navigate(["/login"]);
  // }
}
